import { EventEntityAttribute } from "./additionalCompanyData";
import { APIResponseStatus } from "./api";
import { CompanyFeed } from "./personalization";

export interface NewsResponse {
  feed: Record<emailAddress, CompanyFeed<EventEntityAttribute>[] | null>;
  status: APIResponseStatus;
}
